import React from "react";
import {Header} from "../../components/Header";
import {useSelector, useDispatch} from "react-redux";
import moment from "moment";
import {
    SNSDataList,
    isErrorResponse,
    getListsDetail,
    ListItem,
} from "../../util/api";
import {SetSNSLists} from "../../actions";

type HeaderProps = {
    setOpen: (open: boolean) => void;
};

export const HeaderContainer: React.FC<HeaderProps> = (props) => {
    const tokenSelector = (state: any) => state.auth.token;
    const token = useSelector(tokenSelector);
    const nowLogin = !!token;
    const snsList = useSelector((state: any) => state.snsLists);
    const dispatch = useDispatch();

    const reloadTimeline = async () => {
        const newList: Array<SNSDataList> = [];
        await Promise.all(
            snsList.map(async (l: ListItem) => {
                await getListsDetail(l.id).then((listDetail) => {
                    if (isErrorResponse(listDetail)) {
                        alert("リストの取得に失敗しました。");
                        return;
                    }
                    listDetail.name = l.name;
                    newList.push(listDetail);
                });
            })
        ).then(() => {
            newList.sort((a, b) => a.id - b.id);
            dispatch(SetSNSLists(newList));
            localStorage.setItem("lastUpdatedAt", moment().toString());
        });
    };

    return (
        <Header
            nowLogin={nowLogin}
            reloadTimeline={reloadTimeline}
            setOpen={props.setOpen}
        />
    );
};
